export const DEFAULT_TVL_IN_USD_RANGE = [100_000, 50_000_000_000] // 100k - 50b
export const OVER_50_MLN_TVL_LOWER_BOUND = 50_000_000
